import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const fields = [
  { name: "company_name", label: "Nama Perusahaan" },
  { name: "tagline", label: "Tagline" },
  { name: "about", label: "Tentang Perusahaan", area: true },
  { name: "address", label: "Alamat Kantor", area: true },
  { name: "phone", label: "Telepon" },
  { name: "whatsapp", label: "Nomor WhatsApp (mis. 6281234567890)" },
  { name: "email", label: "Email" },
  { name: "website", label: "Website" },
  { name: "map_embed", label: "URL Embed Google Maps (src iframe)", area: true },
];

export default function SettingsPage() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setForm(r.data || {})).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/settings", form); toast.success("Pengaturan tersimpan"); }
    catch { toast.error("Gagal menyimpan"); } finally { setSaving(false); }
  };

  const inp = "w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold text-sm";

  return (
    <div className="max-w-2xl">
      <h1 className="font-syne font-bold text-3xl text-white mb-1">Info Perusahaan</h1>
      <p className="text-white/50 mb-8">Kelola informasi kontak, alamat, dan peta yang tampil di situs.</p>
      <div className="space-y-4">
        {fields.map((f) => (
          <div key={f.name}>
            <label className="text-xs text-white/50 uppercase tracking-widest mb-1.5 block">{f.label}</label>
            {f.area
              ? <textarea rows={2} value={form[f.name] || ""} onChange={(e) => setForm({ ...form, [f.name]: e.target.value })} className={`${inp} resize-none`} data-testid={`setting-${f.name}`} />
              : <input value={form[f.name] || ""} onChange={(e) => setForm({ ...form, [f.name]: e.target.value })} className={inp} data-testid={`setting-${f.name}`} />}
          </div>
        ))}
        <button onClick={save} disabled={saving} className="btn-gold px-8 py-3 rounded-xl disabled:opacity-60" data-testid="save-settings">{saving ? "Menyimpan…" : "Simpan Perubahan"}</button>
      </div>
    </div>
  );
}
